<template>
  <!-- eslint-disable vue/no-unused-refs -->
  <AppBarLayout>
    <template #default>
      <div
        class="main !tw-overflow-x-hidden tw-flex tw-flex-col tw-justify-start"
      >
        <!-- <backgroundComponent /> -->
        <ActivePathWrapper
          :active-hierarchy="[
            getComponentUiText('app-menu-assess-1'),
            getComponentUiText('app-menu-submenu-assess-vendor-assessments-1'),
            isEdit
              ? getComponentUiText(
                  'app-assessment-vendor-edit-template-title-1',
                )
              : getComponentUiText(
                  'app-assessment-vendor-create-template-title-1',
                ),
          ]"
          :button-title="
            getComponentUiText(
              'app-menu-submenu-assess-vendor-assessments-save-vs-close-button-title-1',
            )
          "
          :button2-title="
            getComponentUiText(
              'app-assessments-vendor-assessment-use-template-button-1',
            )
          "
          :is-outline="true"
          :is-outline2="false"
          :navigate="['', '/assess/vendor/manage', '', '']"
          id-button1="vendor-assess-template-save"
          id-button2="vendor-assess-template-use-template"
          data-cy1="vendor-assess-template-save-and-close-btn"
          data-cy2="vendor-assess-template-use-template-btn"
          :is-button2-enable="!isCheckQuestionInTemplate"
          :is-btn-loading="isBtnLoading"
          :is-btn2-loading="isBtn2Loading"
          @click-button="onSubmit"
          @click-button2="onUseTemplate(route.query.templateId)"
        />
        <VendorCreateTemplate
          id="vendor-assess-template"
          ref="vendorCreateTemplateRef"
          :is-edit="isEdit"
          :template-id="templateId"
          :is-loading="isLoading"
          @is-call-update="checkUpdateApi"
        />
        <div
          class="xl:tw-px-[60px] xl:tw-pt-[41px] xl:tw-pb-[55px] tw-flex-1 tw-flex tw-flex-col tw-border-[1px] tw-border-[#EFF0F1] tw-border-solid tw-px-[10px] tw-py-[40px]"
        >
          <!-- Vender question -->
          <VendorQuestionCreatePage
            ref="vendorQuestionCreatePageRef"
            @is-call-update="checkUpdateApi"
          />
          <!-- Actions buttons -->
          <div class="tw-flex tw-gap-[20px] tw-justify-end tw-items-center">
            <Button1
              id="vendor-assess-template-btn-save"
              data-cy="vendor-assess-template-save-and-close-btn-bottom"
              :class="`tw-min-w-[136px] !tw-h-[39.5px] button button-outline`"
              :title="
                getComponentUiText(
                  'app-menu-submenu-assess-vendor-assessments-save-vs-close-button-title-1',
                )
              "
              :disabled="false"
              :is-loading="isLoading"
              @click="() => onSaveAndClose()"
            />
            <Button1
              id="vendor-assess-template-btn-use-template"
              :class="`button`"
              :disabled="!isCheckQuestionInTemplate"
              :title="
                getComponentUiText(
                  'app-assessments-vendor-assessment-use-template-button-1',
                )
              "
              @click="() => onUseTemplate(route.query.templateId)"
            />
          </div>
        </div>
      </div>
    </template>
  </AppBarLayout>
</template>

<script setup lang="ts">
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import { getComponentUiText } from "@/utils/utilities";
import Button1 from "@/components/common/button1.vue";
import VendorQuestionCreatePage from "@/components/vendor/vendorQuestionCreatePage.vue";
import VendorCreateTemplate from "@/components/vendor/vendorCreateTemplate.vue";
import { useRoute } from "vue-router";
import { computed, onMounted, ref } from "vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import store from "@/store";
import router from "@/router";
import { MODAL_NAME } from "@/utils/constants";

const props = defineProps({
  isEnableButton: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
const isEdit = computed(() => {
  return route.query.isEdit === "true";
});

const templateId: any = computed(() => {
  return route.query.templateId;
});

const isLoading = ref(false);
const isUpdateChecklistRequested = ref(false);
const isShowButton = computed(() => store.state.Vendor.isShowButton);
const vendorCreateTemplateRef = ref<any>(null);
const vendorQuestionCreatePageRef = ref<any>(null);
const isBtnLoading = ref(false);
const isBtn2Loading = ref(false);

const isUpdateQuestion = computed(
  () => store.state.Vendor.isUpdateQuestionItem,
);
const templateEditId = computed(() => store.state.Vendor?.templateEditId);
const isExitsTemplateName = computed(
  () => store.state.Vendor.isExitsTemplateName,
);

const isCheckQuestionInTemplate = computed(
  () => store.getters["Vendor/isCheckQuestionInTemplate"],
);

onMounted(() => {
  if (route.query.templateId) {
    fetchRequestedTemplateDetail();
  }
});

const fetchRequestedTemplateDetail = async () => {
  isLoading.value = true;

  await store.dispatch("Vendor/fetchRequestedTemplateDetail", {
    templateId: route.query.templateId,
  });

  isLoading.value = false;
};
const isSubmit = computed(() => store.state.Vendor.isShowButton);

const onSubmit = async () => {
  isBtnLoading.value = true;
  await new Promise((resolve) => setTimeout(resolve, 500));
  if (!templateEditId.value) {
    await vendorCreateTemplateRef.value.createTemplate();
  }
  await vendorQuestionCreatePageRef.value.submitQuestion();
  if (isUpdateChecklistRequested.value) {
    setTimeout(() => {
      isBtnLoading.value = false;
      router.push({ path: "/assess/vendor/manage" });
    }, 500);
  }
};

const onSaveAndClose = async () => {
  isLoading.value = true;
  if (!templateEditId.value) {
    await vendorCreateTemplateRef.value.createTemplate();
  }
  await vendorQuestionCreatePageRef.value.submitQuestion();
  if (isUpdateChecklistRequested.value) {
    setTimeout(() => {
      isLoading.value = false;
      router.push({ path: "/assess/vendor/manage" });
    }, 500);
  }
};
const checkUpdateApi = (val) => {
  isLoading.value = false;
  isBtnLoading.value = false;
  isUpdateChecklistRequested.value = val;
};

const onUseTemplate = (templateId) => {
  isBtn2Loading.value = true;
  setTimeout(() => {
    isBtn2Loading.value = false;
  }, 500);
  router.push({ path: "/assess/vendor/manage" });
  setTimeout(() => {
    const emitData = {
      component: MODAL_NAME.MODAL_CREATE_NEW_VENDOR_ASSESSMENT,
      properties: {
        value: {},
        title: "",
        description: "",
        buttonText: "",
        buttonRed: false,
        slotCustom: "",
        list: [],
        hiddenHelp: "",
        templateId: Number(templateId),
      },
      events: {
        "update:data": () => {},
        "update:close": () => {},
      },
    };
    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  }, 500);
};
</script>

<style lang="scss" scoped>
.main {
  // background: linear-gradient(64.12deg, #f1f2f3 0%, #eeeff0 100%);
  width: 100%;
  position: relative;
  overflow-x: hidden;
  height: 100%;
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
}

.org-header {
  .org-title-name {
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 100%;
    color: #211f58;
  }

  .org-domain {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 100%;
    color: #878787;
  }
}
.org-header {
  @media (max-width: 991px) {
    padding-left: 10px;
  }
}

.contain {
  @media (max-width: 991px) {
    padding: 40px 10px;
  }
}

@media (max-width: 991px) {
  .main .active-path-header_wrapper {
    padding: 20px 10px;
  }
}

.contain {
  width: 100%;
  position: relative;
  border-top: 1px solid var(--UI-rule, #eff0f1);
}

.header__pen {
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  width: 46px;
  height: 44px;
}

.is_editable {
  cursor: pointer;
  background: var(--Brand-Navy, #211f58);
}

.not_editable {
  cursor: pointer;
  background: var(--UI-white, #fff);
}
.previous-button {
  border: 2px solid #387dff;
  box-shadow: none;
  background: #ffffff;
  color: #387dff !important;

  &.disabled {
    background: var(--ui-light-grey-50, #dbdbdb);
    color: #b7b7b7 !important;
    border: none;
  }
}
.previous-button:hover {
  color: #ffffff !important;
}

.button {
  border: 2px solid #387dff;
  align-items: center;

  &.disabled {
    border: 2px solid #62a2f5;
  }
}

.button-outline {
  border: 2px solid #387dff;
  box-shadow: none;
  background: #ffffff;
  color: #387dff !important;

  &.disabled {
    background: var(--ui-light-grey-50, #dbdbdb);
    color: #b7b7b7 !important;
    border: none;
    cursor: not-allowed;
  }
  &:hover {
    color: #ffffff !important;
  }
}
</style>
